import { Link } from "react-router-dom";
import FeedbackForm from "./components/FeedbackForm";
import { siteIntro } from "@/mocks/comics";

const values = [
  {
    icon: "ri-hd-line",
    title: "高清画质",
    desc: "坚持高清原图呈现，最大程度还原作者笔下的每一个细节与色彩层次。",
  },
  {
    icon: "ri-timer-flash-line",
    title: "及时更新",
    desc: "热门作品持续同步最新章节，配合更新提示，让追更不再错过任何精彩。",
  },
  {
    icon: "ri-layout-grid-line",
    title: "丰富题材",
    desc: "覆盖少年、少女、青年、同人、奇幻、科幻、恋爱、动作等多元题材。",
  },
  {
    icon: "ri-device-line",
    title: "多端流畅",
    desc: "无论电脑还是手机，自适应布局与顺畅翻页带来舒适的连续阅读体验。",
  },
];

export default function About() {
  return (
    <div className="w-full px-4 md:px-6 py-8">
      <nav className="flex items-center gap-1.5 text-xs text-foreground-500 mb-6 flex-wrap">
        <Link to="/" className="hover:text-primary-500 transition-colors">首页</Link>
        <i className="ri-arrow-right-s-line" />
        <span className="text-foreground-950">关于我们</span>
      </nav>

      <section className="rounded-lg bg-secondary-100 border border-background-200 p-6 md:p-10">
        <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs bg-primary-500 text-background-50 mb-4">
          <i className="ri-book-open-line" />
          关于 JMcomic2
        </span>
        <h1 className="font-heading font-extrabold text-2xl md:text-4xl text-foreground-950 max-w-3xl leading-tight">
          让每一部好漫画，都能被高清地看见
        </h1>
        <p className="mt-4 text-sm md:text-base text-foreground-700 leading-relaxed max-w-3xl">
          {siteIntro.paragraphs[0]}
        </p>
        <p className="mt-3 text-sm md:text-base text-foreground-700 leading-relaxed max-w-3xl">
          {siteIntro.paragraphs[1]}
        </p>
      </section>

      <section className="mt-8">
        <h2 className="font-heading font-bold text-xl text-foreground-950 mb-5">我们坚持</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {values.map((item) => (
            <div key={item.title} className="rounded-lg bg-background-100 border border-background-200 p-5">
              <span className="w-11 h-11 rounded-lg bg-accent-100 text-accent-500 flex items-center justify-center mb-3">
                <i className={`${item.icon} text-xl`} />
              </span>
              <h3 className="font-heading font-semibold text-foreground-950">{item.title}</h3>
              <p className="mt-1.5 text-sm text-foreground-700 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="mt-8 grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2">
          <FeedbackForm />
        </div>

        <div className="space-y-6">
          <div className="rounded-lg bg-background-100 border border-background-200 p-5">
            <h2 className="font-heading font-bold text-lg text-foreground-950 mb-4 flex items-center gap-2">
              <i className="ri-contacts-book-2-line text-primary-500" />
              联系我们
            </h2>
            <ul className="space-y-3 text-sm">
              <li className="flex items-center gap-3 text-foreground-700">
                <span className="w-9 h-9 rounded-md bg-background-50 border border-background-200 flex items-center justify-center text-primary-500">
                  <i className="ri-mail-line" />
                </span>
                contact@jmcomic2.example.com
              </li>
              <li className="flex items-center gap-3 text-foreground-700">
                <span className="w-9 h-9 rounded-md bg-background-50 border border-background-200 flex items-center justify-center text-primary-500">
                  <i className="ri-customer-service-2-line" />
                </span>
                在线客服：工作日 10:00 - 18:00
              </li>
              <li className="flex items-center gap-3 text-foreground-700">
                <span className="w-9 h-9 rounded-md bg-background-50 border border-background-200 flex items-center justify-center text-primary-500">
                  <i className="ri-map-pin-line" />
                </span>
                中国 · 上海市 · 数字文创园
              </li>
            </ul>
          </div>

          <div className="rounded-lg bg-background-100 border border-background-200 p-5">
            <h2 className="font-heading font-bold text-lg text-foreground-950 mb-3 flex items-center gap-2">
              <i className="ri-copyright-line text-accent-500" />
              版权与免责说明
            </h2>
            <p className="text-sm text-foreground-700 leading-relaxed">
              {siteIntro.paragraphs[2]}
            </p>
            <p className="mt-3 text-sm text-foreground-700 leading-relaxed">
              如你是作品权利方并希望处理相关内容，请通过上方反馈表单选择“版权申诉”，我们会尽快与你联系。
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}